import { imgUploadToCloud } from "services/category";

const imgUploadToCloudFun = async (propData) => {
  const formData = new FormData();
  formData.append("images", propData);

  const {
    data: { data },
    status,
    code,
  } = await imgUploadToCloud(formData);

  // console.log(" status,code", status, code);

  const cloudData = {
    data,
    status,
    code,
  };
  return cloudData;
};

export default imgUploadToCloudFun;
